// import HomeAs from "./home/Home";

import About from './about/About';
import { HomeAsync } from './home/Home.async';

export { HomeAsync as Home, About };
